import "whatwg-fetch";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import App, { LinkNames } from "./App";
// Do not remove this import, it is used to initialize AppInsights
import AppInsights from "shared/AppInsights";
//Navigation is always visible, import common stuff here
import "../shared/vendorCss";
import { Router } from "react-router-dom";
import { History } from "history";
import StylesheetProvider from "shared/providers/StylesheetProvider";

// currentApp is the react application in main (Environment/Process/etc..)
export const renderNavBar = (browserHistory: History<unknown>, currentApp: LinkNames | null, route = "/:environmentName?/:agentGroupName?") => {
    const rootContainer = document.getElementById("navigationbar");
    if (rootContainer) {
        const root = ReactDOM.createRoot(rootContainer);
        root.render(
            <React.StrictMode>
                <StylesheetProvider>
                    <Router history={browserHistory}>
                        <App
                        isAuthenticated={rootContainer.dataset["isAuthenticated"] === "True"}
                            username={rootContainer.dataset["username"] ?? ""}
                            intercomAppId={rootContainer.dataset["intercomAppId"] ?? ""} {...(rootContainer.dataset)}
                            route={route}
                            activeLink={currentApp}
                        />
                    </Router>
                </StylesheetProvider>
            </React.StrictMode>
        );
    }
}
